import React, { useRef, useState } from 'react'
import LayoutModal, { NewSubmitButton } from '../../components/layouts/Modal';
import FormTextarea from '../../components/forms/Textarea';
import FormInput from '../../components/forms/Input';
import { patchPerusahaanAlumni } from '../../api';
import { saAlert } from '../../helpers';
import SmallButton from '../../components/forms/SmallButton';

function EditPerusahaanAlumni({fetchData, perusahaan}) {

    const [modal, setModal] = useState(false);
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({});
    const formRef = useRef(null);

    const handleOpen = () => {
        setModal(true);
        setForm(perusahaan);
    }

    const handleClose = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setForm({});
        setErrors({});
        setModal(false);
    }

    const handleChange = (e) => {
        setForm((prevState) => ({...prevState, [e.target.name] : e.target.value}))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await patchPerusahaanAlumni(perusahaan.id, form);
            if (res.data.status === "success") {
                handleClose();
                fetchData();
                saAlert(res.data.status, res.data.message);
                console.log(res.data);
            }
        } catch (error) {
            console.log(error.response);
            setErrors(error.response?.data?.errors);
        }
    }

  return (
    <>
        <SmallButton onClick={handleOpen} margin="me-1" type="edit" text="Edit"/>

        <LayoutModal title="Edit Perusahaan" modal={modal} onClose={handleClose}>
            <form ref={formRef} onSubmit={handleSubmit} className='row'>
                <div className='col-lg-6'>
                    <FormInput
                        label='Nama Perusahaan'
                        type='text'
                        name='nama'
                        onChange={handleChange}
                        value={form.nama}
                        error={errors.nama}
                    />
                    <FormTextarea
                        label='Alamat'
                        name='alamat'
                        row={5}
                        onChange={handleChange}
                        value={form.alamat}
                        error={errors.alamat}
                    />
                </div>
                <div className='col-lg-6'>
                    <FormInput
                        label='No Telepon'
                        type='text'
                        name='no_telf'
                        onChange={handleChange}
                        value={form.no_telf}
                        error={errors.no_telf}
                    />
                    <FormInput
                        label='No HP'
                        type='text'
                        name='no_hp'
                        onChange={handleChange}
                        value={form.no_hp}
                        error={errors.no_hp}
                    />
                    <FormInput
                        label='Email'
                        type='email'
                        name='email'
                        onChange={handleChange}
                        value={form.email}
                        error={errors.email}
                    />
                    <FormInput
                        label='PIC'
                        type='text'
                        name='pic'
                        onChange={handleChange}
                        value={form.pic}
                        error={errors.pic}
                    />
                </div>
                <NewSubmitButton className="mt-4" onClose={handleClose}/>
            </form>
        </LayoutModal>
    </>
  )
}

export default EditPerusahaanAlumni